import { Link } from 'react-router-dom';
import { Icon } from '../../design/Icon';
import { useAppTo } from '../../shell/links';

/** État vide (maquette 2a) : espace prêt, deux cartes à zéro et deux actions. « Inviter un membre » attend son service. */
export function EmptyHome() {
  const to = useAppTo();
  return (
    <>
      <div className="hm-grid">
        <article className="hm-card">
          <h2 className="hm-card__title">Mots de passe</h2>
          <p className="hm-muted">0 entrée</p>
        </article>
        <article className="hm-card">
          <h2 className="hm-card__title">Notes</h2>
          <p className="hm-muted">Aucune tâche</p>
        </article>
      </div>
      <section className="hm-empty" aria-labelledby="hm-empty-title">
        <h2 id="hm-empty-title">Votre espace est prêt</h2>
        <p>Aucune activité pour le moment. Ajoutez un premier mot de passe ou invitez un membre de la famille.</p>
        <div className="hm-empty__actions">
          <Link to={to('/vault')} state={{ intent: 'new-password' }} className="lh-btn lh-btn-primary">
            <Icon name="plus" size={18} />
            Ajouter un mot de passe
          </Link>
          <button type="button" className="lh-btn lh-btn-secondary" aria-disabled="true" title="Bientôt disponible">
            <Icon name="user" size={18} />
            Inviter un membre
          </button>
        </div>
      </section>
    </>
  );
}

/** Squelettes de chargement : mêmes emplacements que l'état normal, `aria-busy` sur chaque bloc. */
export function HomeSkeleton() {
  return (
    <div role="status" aria-label="Chargement de l’accueil" className="hm-skeleton">
      <div className="hm-grid" aria-busy="true">
        <div className="hm-card">
          <div className="lh-skeleton" style={{ width: '40%', height: 24 }} />
          <div className="lh-skeleton" style={{ width: '55%', height: 16 }} />
          <div className="hm-sk__chips">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="lh-skeleton" style={{ width: 44, height: 44, borderRadius: 'var(--r-md)' }} />
            ))}
          </div>
        </div>
        <div className="hm-card">
          <div className="lh-skeleton" style={{ width: '30%', height: 24 }} />
          <div className="lh-skeleton" style={{ width: '60%', height: 16 }} />
          <div className="lh-skeleton" style={{ width: '50%', height: 16 }} />
        </div>
      </div>
      <div className="hm-card" aria-busy="true">
        <div className="lh-skeleton" style={{ width: 220, height: 24 }} />
        {[0, 1, 2].map((i) => (
          <div key={i} className="hm-sk__row">
            <div className="lh-skeleton" style={{ width: 36, height: 36, borderRadius: '50%' }} />
            <div className="lh-skeleton" style={{ flex: 1, height: 16 }} />
            <div className="lh-skeleton" style={{ width: 64, height: 16 }} />
          </div>
        ))}
      </div>
    </div>
  );
}
